/**
 * AiChar · 角色气泡素材
 * ------------------------------------------------------------
 * 原 AiBuddy（机器人）的能力迁移至此：系统操作小技巧（含真实快捷键）+ 心灵鸡汤。
 * 悬浮壳（AiBuddy.vue）负责轮播；新增素材直接往 TIPS 里加即可。
 */
export interface AiTip {
  kind: 'tip' | 'mood'
  text: string
}

export const TIPS: AiTip[] = [
  { kind: 'tip', text: '按 / 呼出全局搜索，应用、能力、节点、对象都能直达。' },
  { kind: 'tip', text: 'Esc 返回上一级，Alt+H 回到默认主页。' },
  { kind: 'tip', text: 'Ctrl+K 新建会话；任何页面打开即自动成为上方页签。' },
  { kind: 'tip', text: '右上角铃铛看通知；头像进设置中心，可切主题与语言。' },
  { kind: 'tip', text: '架构页左侧目录逐级展开，点最末一级才出详情，试试搜索更快。' },
  { kind: 'tip', text: '我的工资条默认隐藏，输手机验证码才解锁，安全第一。' },
  { kind: 'mood', text: '把复杂留给系统，把判断力留给自己。' },
  { kind: 'mood', text: '今天推进 1%，一年就是 37 倍。' },
  { kind: 'mood', text: '先完成，再完美。' },
  { kind: 'mood', text: '休息也是工作的一部分，别亏待自己。' }
]
